export default {
  amazonPrimeFaq:
    'https://faq.paidy.com/amazon%E3%81%AE%E3%81%94%E5%88%A9%E7%94%A8%E3%81%AB%E3%81%A4%E3%81%84%E3%81%A6?hsLang=ja-jp',
  smsFaq:
    'https://faq.paidy.com/%E3%83%9A%E3%82%A4%E3%83%87%E3%82%A3%E3%81%8B%E3%82%89sms%E3%81%8C%E5%B1%8A%E3%81%8D%E3%81%BE%E3%81%9B%E3%82%93-',
};
